import { hideAll } from "tippy.js";

import { canv } from "@/canv/global.js";
import { eventEmitter } from "@/eventEmitter";
import { ActiveVoteTool } from "@/tools/ActiveVoteTool";
import { ArrowTool } from "@/tools/ArrowTool";
import { CommentTool } from "@/tools/CommentTool/CommentTool";
import { cardTool } from "@/tools/cardTool/cardTool.js";
import { clipTool } from "@/tools/clipTool/clipTool.js";
import { CursorTool } from "@/tools/cursorTool";
import { dragTool } from "@/tools/dragTool/dragTool";
import { emoteTool } from "@/tools/emoteTool/emoteTool.js";
import { frameTool } from "@/tools/frameTool/frameTool.js";
import { mediaTool } from "@/tools/mediaTool/mediaTool.js";
import { MindMapTool } from "@/tools/mindMapTool/mindMapTool.js";
import { MoreStickersTool } from "@/tools/moreTool/MoreStickersTool";
import { moreTool } from "@/tools/moreTool/moreTool.js";
import { PenTool } from "@/tools/PenTool";
import { PresentationTool } from "@/tools/PresentationTool";
import { StickersTool } from "@/tools/StickersTool";
import { shapeTool } from "@/tools/shapeTool/shapeTool.js";
import { stickerTool } from "@/tools/stickerTool";
import { TemplatesTool } from "@/tools/TemplatesTool";
import { tableTool } from "@/tools/tableTool/tableTool.js";
import { textTool } from "@/tools/textTool/textTool.js";
import type { Tool, ToolName, Tools } from "@/tools/types";
import { EmbedTool } from "./embedTool/embedTool";
import { VoteTool } from "./VoteTool";

export class toolBox {
    constructor() {
        this.Tools = {
            cursorTool: new CursorTool(),
            stickerTool: new stickerTool(),
            textTool: new textTool(),
            shapeTool: new shapeTool(),
            penTool: new PenTool(),
            arrowTool: new ArrowTool(),
            mindMapTool: new MindMapTool(),
            frameTool: new frameTool(),
            emoteTool: new emoteTool(),
            mediaTool: new mediaTool(),
            moreTool: new moreTool(),
            tableTool: new tableTool(),
            cardTool: new cardTool(),
            dragTool: new dragTool(),
            templatesTool: new TemplatesTool(),
            stickersTool: new StickersTool(),
            moreStickerTool: new MoreStickersTool(),
            clipTool: new clipTool(),
            activeVoteTool: new ActiveVoteTool(),
            voteTool: new VoteTool(),
            commentTool: new CommentTool(),
            embedTool: new EmbedTool(),
            presentationTool: new PresentationTool(),
        };

        this.currentTool = this.getFirstTool();
        eventEmitter.dispatch("toolbox.currentTool", { tool: this.currentTool });
    }

    TryAction(type: string) {
        if (!this.currentTool) {
            return;
        }

        if (this.isDisabled && this.currentTool.name !== "dragTool") {
            return;
        }

        if ("TryAction" in this.currentTool) {
            this.currentTool.TryAction(type);
        }
    }

    drawTool() {
        if (this.currentTool != null) {
            this.currentTool.draw();
        }
    }

    getCurrentTool() {
        return this.currentTool;
    }

    getFirstTool() {
        return this.Tools.cursorTool;
    }

    TryGetToolByName<T extends ToolName>(name: T) {
        return this.Tools[name];
    }

    switchTo(tool: Tool, isToggleMenu = true) {
        hideAll();
        if (!this.currentTool) {
            canv.redraw();
            return;
        }

        if (
            tool.name === this.currentTool.name &&
            this.currentTool.name === "penTool" &&
            isToggleMenu
        ) {
            (this.currentTool as PenTool).reopenOrCloseSubmenu();
        } else {
            document.body.style.cursor = "default";
            this.currentTool.unselect();
            this.currentTool = tool;
            eventEmitter.dispatch("toolbox.currentTool", { tool: this.currentTool });
            this.currentTool.select();
        }
        canv.redraw();
    }

    switchToByName(toolName: ToolName) {
        const tool = this.TryGetToolByName(toolName);
        if (!tool) {
            return;
        }

        this.switchTo(tool);
    }

    switchToShapeTool(mode) {
        this.switchToByName("shapeTool");
        if (mode && (this.currentTool as shapeTool).subMenuShapes.includes(mode)) {
            (this.currentTool as shapeTool).setMode(mode);
        }
        canv.redraw();
    }

    Tools: Tools;
    currentTool: Tool | null = null;
    isDisabled = false;
    toolBox: HTMLElement | null = null;
}
